// src/utils/sensitiveWords.js


import { loadTxtFile} from  './readText'
import Vue from 'vue'
const vm = new Vue()
class SensitiveWordsService {
    constructor() {
      this.words = [] 
      this.isLoaded = false
    }

    // checkSensitiveWords(text, target) {
    //     const detectedWords = this.CheckSensitiveWords(text, { showWarning: true })
        
    //     if (detectedWords.hasSensitive) {
    //       // 可以在这里添加视觉反馈
    //       this.highlightSensitiveElement(target, detectedWords.words)
    //     } else {
    //       this.removeHighlight(target)
    //     }
    //   }
      
      highlightSensitiveElement(element, words) {
        element.style.borderColor = '#f56c6c'
        element.style.boxShadow = '0 0 0 2px rgba(245,108,108,.2)'
      }
      
      removeHighlight(element) {
        element.style.borderColor = ''
        element.style.boxShadow = ''
      }
      async checkSensitiveWords (text) {
        if (!text || !this.words.length) return []
        
        const detectedWords = []
        this.words.forEach(word => {
          if (word && text.includes(word)) {
            detectedWords.push(word)
          }
        })
        
        return detectedWords
      }
  // 全局敏感词检测方法
      async CheckSensitiveWords(text, options = {}) {
        const {
          autoFilter = true,    // 是否自动过滤
          showWarning = true,    // 是否显示警告
          replacement = '***'    // 替换字符
        } = options
  
        if (!text) {
          return { hasSensitive: false, words: [], filteredText: text }
        }
  
        const detectedWords = this.detect(text)
        const hasSensitive = detectedWords.length > 0
        let filteredText = text
        if (hasSensitive && autoFilter) {
          filteredText = this.filter(text, replacement)
        }
        // 更新状态
        this.sensitiveWordsDetected = hasSensitive
        this.lastDetectedWords = detectedWords
        // 显示警告
        if (hasSensitive && showWarning) {
          this.showSensitiveWarning(detectedWords)
        }
  
        return {
          hasSensitive,
          words: detectedWords,
          filteredText,
          originalText: text
        }
      }
  
      // 显示敏感词警告
       showSensitiveWarning(words) {
        // 使用 Element UI 的通知
        
        // if (vm.$notify) {
        //     vm.$notify({
        //     title: '敏感词提示',
        //     message: `发现敏感词: ${words.join(', ')}`,
        //     type: 'warning',
        //     duration: 3000,
        //     position: 'bottom-right'
        //   })
        // }
        
        // 或者使用 Message
        if (vm.$message) {
            vm.$message.warning(`发现敏感词: ${words.join(', ')}`)
        }
      }
  
      // 全局过滤方法
       filterSensitiveWords(text, replacement = '***') {
        return this.filter(text, replacement)
      }
     isInputElement(el) {
        const tagName = el.tagName.toLowerCase()
        return tagName === 'input' || tagName === 'textarea'
      }
      
    // 加载敏感词库
     async loadWords() {
      try {
        // 可以从本地存储、API或静态文件加载
        const response = await  loadTxtFile(process.env.VUE_APP_BASE_API.replace("api","uploads") +'/webmanage/filterText/sensitive-words.txt')
        this.words = response || []
        this.isLoaded = true
        console.log('敏感词库加载成功:', this.words.length)
      } catch (error) {
        console.error('加载敏感词库失败:', error)
      }
    }
  
    // 检测敏感词
    detect(text) {
      if (!text || !this.isLoaded) return []
      const detectedWords = []
      this.words.forEach(word => {
        if (word && text.includes(word)) {
          detectedWords.push(word)
        }
      })
      return detectedWords
    }
  
    // 过滤敏感词
    filter(text, replacement = '***') {
      if (!text || !this.isLoaded) return text
      
      let filteredText = text
      this.words.forEach(word => {
        if (word) {
          const regex = new RegExp(this.escapeRegExp(word), 'g')
          filteredText = filteredText.replace(regex, replacement)
        }
      })
      return filteredText
    }
  
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }
  
    async fetchSensitiveWords() {
      // 方式1: 从API获取
      // return await axios.get('/api/sensitive-words')
      
      // 方式2: 从本地JSON文件获取
      // return await import('@/assets/sensitive-words.json')
      
      // 方式3: 硬编码（开发阶段）
      return {
        words: [
          '暴力', '毒品', '赌博', '色情', '诈骗', 
          '反动', '敏感词', '违禁词', '测试敏感词'
        ]
      }
    }
  }
  
  export default new SensitiveWordsService()